<template>
  <div class="d-flex justify-content-around h-100" slot="actions" slot-scope="props">
    <input v-if="$route.name ==='orders' ||
            $route.name ==='ordersControl' ||
            $route.name ==='ordersProtect' ||
            $route.name ==='ordersCancellations' ||
            $route.name ==='ordersCollection' ||
            $route.name ==='ordersTasks' ||
            $route.name ==='ordersClaims' ||
            $route.name ==='renewals' ||
            $route.name ==='leads'" type="checkbox" name="preview-order-list" :id=id class="align-self-center"
           :value="value" @change="$emit('catchPreviewList', phoneNumber, productSelectedRow)"/>
  </div>
</template>

<script>
import alert from "@/components/alert.vue";

export default {
  name: 'RowAction',
  props: {
    phoneNumber:String,
    productSelectedRow:Object,
    value:String,
    id:String
  },
  data() {
    return {
      //catchPreviewList:this.catchPreviewList,
      //phoneNumber:this.phoneNumber,
    }
  },

}
</script>
